module.exports = __webpack_public_path__ + "media/images/pikkachan_matome-4902778e2a19949ebad3551da4bf60fe.svg";